RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CompanySearch = Marionette.LayoutView.extend({
        template: '#adminCompanySearchTemplate',

        ui: {
            searchInput: '.x-company-search'
        },

        eventsNotToDebounce: {
            'keydown @ui.searchInput': 'onSearchKeydown'
        },

        events: {
            'input @ui.searchInput': 'search'
        },

        regions: {
            results: '.company-results'
        },

        search: function () {
            const me = this;

            const query = $.trim(me.ui.searchInput.val()).toLowerCase();
            if (me.searchCollection.preventEmptySearch && !query.length) {
                me.collection.reset([]);
                return me.showResults(_.result(me.searchCollection, 'emptyMessage'));
            }
            me.results.showLoading(null, {
                block: true
            });
            me.previousSearch = query;

            const deferred = RivalIQ.utils.async.callbackToDeferred(function (error) {
                if (me.isDestroyed) {
                    return;
                }

                if (error) {
                    switch (error.status) {
                        case 0:
                            return;
                        default:
                            return RivalIQ.execute('alert:danger', 'An error occurred searching for companies');
                    }
                }

                me.collection.reset(me.searchCollection.models);
                me.showResults(_.result(me.searchCollection, 'emptyMessage'));
            });

            me.searchCollection.search(query).done(deferred.resolve).fail(deferred.error);
        },

        onSearchKeydown: function (e) {
            const me = this;

            if (e.which === 13) {
                e.preventDefault();
                me.search();
            }
        },

        onShow: function () {
            const me = this;

            me.searchCollection = new RivalIQ.apps.Admin.collections.Companies();
            me.search();
            me.showResults();

            me.ui.searchInput.focus();
        },

        showResults: function (emptyMessage) {
            const me = this;

            me.results.show(new views.Companies({
                emptyMessage: emptyMessage,
                collection: me.collection
            }));
        }

    });
});
